
import { mapActions } from 'pinia'
import { defineComponent } from '@vue/composition-api'
import type { ProductExtended } from '~/type/product/Product'
import OrderReview from '~/components/user/OrderReview/OrderReview.vue'
import type { Review } from '~/type/Review'
import { useAuthStore } from '~/store/modal/auth'
import { useUserStore } from '~/store/user'
import UIActionEntity from '~/data/UIActionEntity/UIActionEntity.vue'

export default defineComponent({
  name: 'CreateReview',
  components: {
    UIActionEntity,
    OrderReview,
  },
  inject: ['emitter'],
  async asyncData({ app, params }) {
    try {
      const response = (
        await app.$api.product.getByID({
          id: params.id,
        })
      )?.result
      return { product: response.product }
    }
    catch (e) {
      return {
        loadError: true,
      }
    }
  },
  data(): { loadError: boolean; product?: ProductExtended } {
    return {
      loadError: false,
      product: undefined,
    }
  },
  head() {
    return {
      meta: [
        {
          name: 'robots',
          content: 'noindex',
        },
      ],
    }
  },
  mounted() {
    this.$emitter.emit('review-created', { event: 'review_created' } as never)
  },
  methods: {
    ...mapActions(useAuthStore, { showAuthModal: 'enable' }),
    send(cb: (data: Review) => Promise<void>, data: Review) {
      const userState = useUserStore(this.$nuxt.context)
      const callback = () => cb({ ...data, code: this.product?.id, name: userState.user?.name })
      if (userState.userAuth) {
        callback()
      }
      else {
        /**
        * Нужно подождать, пока данные пользователя не появятся после авторизации
        */
        this.showAuthModal({
          // eslint-disable-next-line vue/valid-next-tick
          onComplete: () => this.$nextTick(() => callback()),
        })
      }
    },
  },
})
